import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const InstagramIcon = () => (
  <span className="social-icon social-icon-instagram">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <rect x="5" y="5" width="14" height="14" rx="3.5" />
      <circle cx="12" cy="12" r="3" />
      <circle cx="16.8" cy="7.2" r="0.75" className="icon-dot" />
    </svg>
  </span>
);

const FacebookIcon = () => (
  <span className="social-icon social-icon-facebook">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M13.8 20v-7h2.4l.35-3h-2.75V8.2c0-.95.3-1.6 1.65-1.6h1.55V4c-.3-.05-1.25-.15-2.35-.15-2.35 0-3.95 1.45-3.95 4.15V10H8.2v3h2.5v7h3.1Z" />
    </svg>
  </span>
);

const WhatsAppIcon = () => (
  <span className="social-icon social-icon-whatsapp">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M12 4.5a7.5 7.5 0 0 0-6.45 11.35L4.5 19.5l3.8-1a7.5 7.5 0 1 0 3.7-14Z" />
      <path d="M9.1 8.4c.2-.2.45-.25.7-.15l1 .45c.2.1.3.25.35.5l.2.8c.05.2 0 .4-.15.55l-.45.5c.65 1.05 1.45 1.8 2.55 2.35l.45-.45c.15-.15.35-.2.55-.1l.9.4c.2.1.35.25.35.5v.55c0 .3-.15.55-.4.7-.4.25-.9.35-1.35.25-1.2-.25-2.45-.95-3.55-2-1.1-1.05-1.8-2.3-2.05-3.45-.1-.5 0-1 .3-1.4Z" />
    </svg>
  </span>
);

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-top">

          <div className="footer-hero">
            <h2>
              Pure by nature, pure by
              <br />
              culture<span className="footer-period">.</span>
            </h2>

            <p>The Pahadi standard for every jar.</p>
          </div>

          <div className="footer-brand">
            <img src="/logo-white.png" alt="PureJar" />

            <div className="footer-brand-copy">
              <h3>PureJar</h3>
              <span>PROUDLY PAHADI</span>
            </div>
          </div>

        </div>

        <div className="footer-divider" />

        <div className="footer-main">

          <div className="footer-column">
            <h5>EXPLORE</h5>
            <Link to="/about">Our Story</Link>
            <Link to="/products">All Products</Link>
            <Link to="/partner">Partner With Us</Link>
            <Link to="/careers">Careers</Link>
            <Link to="/creator-collab">Creator Collab</Link>
          </div>

          <div className="footer-column">
            <h5>LEGAL</h5>
            <Link to="/terms">Terms of Use</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/refund-policy">Refund Policy</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
          </div>

          <div className="footer-column">
            <h5>QUICK LINKS</h5>
            <Link to="/products">Shop Now</Link>
            <Link to="/faq">FAQs</Link>
            <Link to="/contact">Contact Us</Link>
            <Link to="/track">Track Order</Link>
          </div>

          <div className="footer-column footer-pahadi">
            <h5>WE'RE PAHADI</h5>

            <p>
              We source India's finest
              <br />
              natural products.
            </p>

            <div className="footer-social">

              <a
                href="https://instagram.com/purejarcafe"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
              >
                <InstagramIcon />
              </a>

              <a
                href="https://facebook.com/purejarcafe"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FacebookIcon />
              </a>

              <a
                href="https://wa.me/918750128338"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
              >
                <WhatsAppIcon />
              </a>

            </div>
          </div>

        </div>

        <div className="footer-divider" />

        <div className="footer-partners">

          <div className="footer-partner">
            <span>SECURED PAYMENTS BY</span>
            <strong>Razorpay</strong>
          </div>

          <div className="footer-partner">
            <span>SHIPPING PARTNER</span>
            <strong>Shiprocket</strong>
          </div>

          <div className="footer-partner">
            <span>GET IN TOUCH</span>
            <a href="mailto:wecare@purejar.in">
              wecare@purejar.in
            </a>
          </div>

        </div>

        <div className="footer-divider" />

        <div className="footer-contact">

          <div className="footer-contact-item">
            <span>HEAD OFFICE</span>
            <p>Neoteric Roots Pvt. Ltd., Uttarakhand</p>
          </div>

          <div className="footer-contact-item">
            <span>EMAIL</span>
            <a href="mailto:wecare@purejar.in">
              wecare@purejar.in
            </a>
          </div>

          <div className="footer-contact-item">
            <span>WHATSAPP</span>
            <a href="https://wa.me/918750128338">
              +91 87501 28338
            </a>
          </div>

          <div className="footer-contact-item">
            <span>FSSAI</span>
            <p>22624038000343</p>
          </div>

        </div>

        <div className="footer-divider footer-bottom-divider" />

        <div className="footer-copyright">
          <p>
            © 2026 Neoteric Roots Private Limited. All Rights Reserved.
          </p>

          <p>
            GST: 05AAJCN1056D1ZU &nbsp;|&nbsp;
            CIN: U82990UT2023PTC016158
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
